
import React from 'react';
import { observer } from 'mobx-react';
import { connect } from 'react-redux';
import { withRouter } from 'helpers/ModuleHelper';
import { clickOutSide } from 'helpers/PageHelper';
import { injectIntl } from 'react-intl';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import LightBox from 'components/LightBox/LightBox';
import NavDropdown from 'react-bootstrap/NavDropdown';
import * as ConfigTypes from 'config/ConfigTypes';
import * as actions from 'store/actions';
import logo from 'assets/images/logo.svg';
import { getBaseName, pubPath, isLocal, isHome } from 'helpers/AppHelper';
import { getCartCount, showFeCartMsg } from 'helpers/CartHelper';
import { Link } from 'react-router-dom';
import { faPlus, faMinus, faHome, faUser } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { capitalize } from 'helpers/TypeHelper';
import { clearStorage } from 'helpers/AuthHelper';


import './Navigation.scss';

const Navigation = observer(
    class NavLinks extends React.Component {
        state = {
            language: "de",
            cliplist: [],
            currentClip: {},
            navClasses: {},
            active: { [ConfigTypes.HOME]: true },
            displaySubItems: ConfigTypes.NONE,
            currentSubItems: [],
            baseName: getBaseName(),
            navRef: React.createRef(),
            msgId: "navigation.main.heading",
            obj: {}
        }

        fm = ({ id }) => this.props.intl.formatMessage({ id });

        closeWindow = () => {
            window.close();
            if (!window.closed) {
                window.open("about:blank", "_self");
                setTimeout(() => {
                    window.close();
                }, 100);
            }
        }

        showMainSdkSite = () => {
            return ConfigTypes.MAIN_SDK_SITE.map((item, i) => (
                <a href={item.link} target="_blank" key={`navigation_main_${i}`}>
                    &#8594; {this.props.intl.formatMessage({ id: item.intl })}
                </a>))
        }

        toggleLang = () => {
            const { lg } = this.props.mediaObjects;
            let language;
            if (lg === ConfigTypes.DE) language = ConfigTypes.EN;
            else language = ConfigTypes.DE;
            return language;
        }

        initData = () => {
            const { lg } = this.props.mediaObjects;
            this.setState({ language: lg });
            clickOutSide(this.state.navRef, () => {
                this.setState({ displaySubItems: ConfigTypes.NONE });
            });
            this.setHeading();
            //Auth
            const { isLoggedIn } = this.props.authObjects;
            if (isLoggedIn) {
                this.props.getCart();
                this.props.getWatchlists();
                let obj = getCartCount({ cartObjects: this.props.cartObjects });
                this.setState({ obj: obj });
            }
            this.setState({ isLoggedIn });
        }

        setActiveNav = (item) => () => {
            let currentSubItems = [];
            let display;
            let pathname = window.location.pathname;
            if (this.state.displaySubItems === ConfigTypes.BLOCK) {
                display = ConfigTypes.NONE;
            } else display = ConfigTypes.BLOCK;

            if (item && item.subitems) {
                currentSubItems = item.subitems;
            }
            this.setState({
                currentSubItems: currentSubItems,
                displaySubItems: display,
                currentNav: item.name,
                active: { [`${item.name}`]: true }
            });
            if (item && item.name) {
                this.props.updateMediaObjects({
                    currentNav: item.name,
                    viewMode: item.name
                });
            }
            if (pathname != this.state.baseName) {
                this.props.router.navigate("/");
            }
        }

        changeLanguage = () => {
            let lg = this.toggleLang();
            this.props.updateMediaObjects({ lg });
        }


        clearData = () => {
            if (!isHome()) this.props.router.navigate("/");
            clearStorage();
            this.props.setInitialState({})
            this.setState({ isLoggedIn: false });
        }

        handleAuthClick = () => {
            const { isLoggedIn } = this.props.authObjects;
            if (isLoggedIn) {
                this.props.logOutFeUser({ cb: this.clearData });
                this.clearData();
            }
            else {
                this.props.updateAuthObjects({ showAuth: true });
            }
        }

        onLogOut = () => {
            const { isLoggedIn } = this.props.authObjects;
            if (isLoggedIn) {
                this.setState({ userBox: false });
                this.props.logOutFeUser({ cb: this.clearData });
                this.clearData();
            }
        }

        showNavHeading = () => {
            return (
                <h1 className="navigation-main-heading">
                    {this.props.intl.formatMessage({ id: this.state.msgId })}
                </h1>)
        }

        showNavSubItems = (item) => {
            if (item.name == this.state.currentNav) {
                return this.state.currentSubItems.map((el, i) => (
                    <Link to={`/${el.name}`} key={`navigationSubItem${i}`}>
                        {this.props.intl.formatMessage({ id: el.intl })}
                        <div className="appnavbar-subsubitems" >
                            {el && el.subitems && el.subitems.length && el.subitems.map(entry => (
                                <Link to={`/${el.name}/${entry.name}`} key={`navigationSubItemSub${i}`}>
                                    &#8594; {this.props.intl.formatMessage({ id: entry.intl })}
                                </Link>))}
                        </div>
                    </Link>))
            }
        }

        setHeading = () => {
            let msgId = "navigation.main.heading";
            // if (viewMode === ConfigTypes.SEARCH_PAGE || viewMode === ConfigTypes.SEARCH_LIST) {
            //     msgId = "navigation.main.search";
            // }
            this.setState({ msgId });
        }

        showHomeNav = () => {
            return (
                <Nav.Link href={isLocal() ? "/" : getBaseName()}>
                    <span className="navigation-home">
                        <FontAwesomeIcon icon={faHome} className="navigation-icon" />
                        {this.props.intl.formatMessage({ id: "data.nav.home" })}
                    </span>
                </Nav.Link>)
        }

        //CART BEGIN
        setCartMode = (mode) => {
            this.setState({ mode });
            this.props.updateMediaObjects({ viewMode: ConfigTypes.CART_MAINPAGE });
            if (!isHome()) this.props.router.navigate("/");
            setTimeout(() => this.props.updateCartObjects({ shopForm: mode }), 100);
        }
        onCartClick = () => {
            const { itemsCartList } = this.props.cartObjects;
            if (!itemsCartList || (itemsCartList.length == 0)) {
                this.props.updateCartObjects({ cartMessage: ConfigTypes.CART_EMPTY });
            } else this.setCartMode(ConfigTypes.CART);

            this.props.getCart();
        }

        onWishList = () => {
            const { itemsWishList, worksWishList } = this.props.cartObjects;
            if ((!itemsWishList && !worksWishList) || ((!itemsWishList.length && !worksWishList.length))) {
                this.props.updateCartObjects({ cartMessage: ConfigTypes.WISHLIST_EMPTY });
            } else this.setCartMode(ConfigTypes.WISHLIST);
        }

        onRentalList = () => {
            const { itemsRentalList } = this.props.cartObjects;
            this.setCartMode(ConfigTypes.RENTALLIST);
            // if ((!itemsRentalList) || (!itemsRentalList.length)) {
            //     this.props.updateCartObjects({ cartMessage: ConfigTypes.RENTALLIST_EMPTY });
            // } else this.setCartMode(ConfigTypes.RENTALLIST);
        }

        onProfile = () => {
            //const { showProfile } = this.props.profileObjects;
            this.props.updateProfileObjects({ showProfile: true });
        }

        showWishCartBox = () => {
            if (ConfigTypes.SHOW_CART) {
                //let obj = getCartCount({ cartObjects: this.props.cartObjects });
                return (
                    <div className="navigation-cart">
                        {ConfigTypes.NAV_CART_TABS.map(tab => {
                            let count = "", active = "";
                            if (this.state.obj[`${tab.mode}Count`]) count = '(' + this.state.obj[`${tab.mode}Count`] + ')';
                            if (this.state.mode == tab.mode) active = 'navigation-active';
                            return (
                                <div className={`navigation-cart-btn ${active} ${tab.htmlClasses || ''}`}
                                    onClick={this[tab.onClick]}>
                                    {tab.intl && this.props.intl.formatMessage({ id: tab.intl })}
                                    <span>&nbsp;{count}</span>
                                    <FontAwesomeIcon icon={tab.icon} />
                                </div>
                            )
                        })}
                    </div>
                )
            }
        }
        //CART END

        showHomeBox = () => {
            return (
                <Nav.Link href={isLocal() ? "/" : getBaseName()}>
                    <div className="navigation-home">
                        <div>
                            <span> <FontAwesomeIcon icon={faHome} className="navigation-icon" /></span>
                            {this.props.intl.formatMessage({ id: "data.nav.home" })}
                        </div>
                        <div />
                    </div>
                </Nav.Link>)
        }

        showLangBox = () => {
            if (ConfigTypes.SHOW_LANG) {
                let baseName = getBaseName();
                if (baseName == '/') baseName = "";
                return (
                    <div className="navigation-lang" onClick={this.changeLanguage}>
                        <span>
                            <img src={`${baseName}/flags/${this.state.language}.png`} />
                        </span>
                        <span>
                            {capitalize(this.state.language)}
                        </span>
                    </div>
                )
            }
        }

        showAuthBox = () => {
            if (ConfigTypes.SHOW_AUTH) {
                return (
                    <div className="navigation-auth">
                        <div>
                            <div className="navigation-loggedIn">
                                {this.state.isLoggedIn && <span onClick={() => this.setState({ userBox: !this.state.userBox })}>
                                    <FontAwesomeIcon icon={faUser} /></span>}
                                {this.state.userBox && (
                                    <div className="navigation-userbox">
                                        {ConfigTypes.USERPROFILE_ITEMS.map((item, i) => (
                                            <div key={`profile_${i}${item.name}`} className="navigation-userbox-item"
                                                onClick={this[item.onClick]}>
                                                {item.icon && <FontAwesomeIcon icon={item.icon} />}{this.fm({ id: item.intl })}
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {/* {this.state.isLoggedIn ? this.props.intl.formatMessage({ id: "data.navigation.loggedIn" }) :
                                    this.props.intl.formatMessage({ id: "data.navigation.notLoggedIn" })} */}
                            </div>
                        </div>
                        <div>
                            <span className="navigation-login" onClick={this.handleAuthClick}>
                                {!this.state.isLoggedIn && this.props.intl.formatMessage({ id: "data.navigation.login" })}
                            </span>
                        </div>
                    </div>
                )
            }
        }

        showTopRight = () => {
            const { isLoggedIn } = this.props.authObjects;
            if (ConfigTypes.REFRESH_HOME) return this.showHomeNav();
            return (
                <div className="navigation-homebox">
                    {isLoggedIn && this.showWishCartBox()}
                    {this.showHomeBox()}
                    {this.showLangBox()}
                    {this.showAuthBox()}
                </div>
            )
        }

        onHomeClick = () => {
            if (!isHome()) this.props.router.navigate("/");
            this.props.updateMediaObjects({ viewMode: ConfigTypes.HOME });
        }

        reloadCart = ({ prev }) => {
            const { worksWishList, itemsWishList, itemsCartList, cartMsg } = this.props.cartObjects;
            if ((prev.cartObjects.itemsCartList != itemsCartList)
                || (prev.cartObjects.itemsWishList != itemsWishList)
                || (prev.cartObjects.worksWishList != worksWishList)) {
                let obj = getCartCount({ cartObjects: this.props.cartObjects });
                console.log("LOGS: Navigation obj", obj);
                this.setState({ obj: obj });
            }

            if (!prev.cartObjects.cartMsg && cartMsg) {
                showFeCartMsg({ msg: cartMsg, fm: this.fm, props: this.props });
                this.props.updateAuthObjects({ cartMsg: '' });
            }
        }

        componentDidUpdate(prev) {
            const { cliplist, lg, viewMode } = this.props.mediaObjects;
            const { isLoggedIn, shouldLogOut } = this.props.authObjects;
            if (prev.mediaObjects != this.props.mediaObjects) {
                if (prev.mediaObjects.cliplist != cliplist) {
                    this.setState({ cliplist: cliplist });
                }
                if (prev.mediaObjects.viewMode != viewMode) {
                    this.setHeading();
                }

                if (prev.mediaObjects.lg != lg) {
                    this.setState({ language: lg });
                }
            }
            if (prev.authObjects.isLoggedIn != isLoggedIn) {
                // this.setState({ isLoggedIn: this.props.authObjects.isLoggedIn });
                // if (isLoggedIn) this.props.getCart();
                if (isLoggedIn) this.initData();
            }

            if (!prev.authObjects.shouldLogOut && shouldLogOut && isLoggedIn) {
                if (!isHome()) this.props.router.navigate("/");
                this.props.logOutFeUser({ cb: this.clearData });
                this.clearData();
                this.props.updateAuthObjects({ shouldLogOut: false });
                console.log("LOGS: NAVIGATION ShouldLogOut!!");
            }

            if (prev.cartObjects != this.props.cartObjects) {
                this.reloadCart({ prev });
            }
        }

        componentDidMount() {
            this.initData();
        }

        render() {
            return (
                <div className="appnavigation">
                    <div className="appnavigation-mainlink">
                    </div>
                    <Navbar bg="white" expand="lg" ref={this.state.navRef}>
                        {ConfigTypes.MAIN_SDK_SITE.map((item, i) => (
                            <Navbar.Brand href={item.link} target="_blank" key={`navbarBrand${i}`}
                                className="appnavigation-brand">
                                <img src={logo} />
                            </Navbar.Brand>
                        ))}
                        <Navbar.Toggle aria-controls="basic-navbar-nav" />
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="navigation-middle me-auto">
                                {/* {this.showNavHeading()} */}
                            </Nav>
                            <Nav>
                                {/* <div className="navigation-img-box">
                                    <img className="navigation-img-lg" src={`${pubPath()}${ConfigTypes.BKM_LOGO}`} />
                                </div> */}
                                {/* {ConfigTypes.NAVIGATION_ITEMS.map((item, i) => (
                                    <Nav.Link className={`${this.state.active[item.name] ? 'navbar-active' : ''}`}
                                        key={`navbar${i}`} href="#" active={this.state.active[item.name]}
                                        onClick={this.setActiveNav(item)}>
                                        {item.isImg ? <img
                                            className={item.htmlClass ? item.htmlClass : "navigation-img"}
                                            src={`${pubPath()}/${item.url}`} />
                                            : this.props.intl.formatMessage({ id: item.intl })}
                                    </Nav.Link>
                                ))} */}
                                {/* <Nav.Link href={isLocal() ? "/" : getBaseName()}>
                                    <FontAwesomeIcon icon={faHome} className="navigation-icon" />
                                </Nav.Link> */}
                            </Nav>
                            {this.showTopRight()}
                            {/* <div className="appnavigation-close" onClick={this.closeWindow}>
                                <span> <FontAwesomeIcon icon={faPlus} /></span>
                            </div> */}
                        </Navbar.Collapse>
                    </Navbar>
                </div>
            )
        }
    }
)

const mapStateToProps = (state) => ({
    mediaObjects: state.media.mediaObjects,
    authObjects: state.auth.authObjects,
    cartObjects: state.cart.cartObjects,
    profileObjects: state.profile.profileObjects
});

const mapDispatchToProps = (dispatch) => ({
    updateMediaObjects: (obj) => dispatch(actions.updateMediaObjects(obj)),
    updateAuthObjects: (obj) => dispatch(actions.updateAuthObjects(obj)),
    updateCartObjects: (obj) => dispatch(actions.updateCartObjects(obj)),
    updateProfileObjects: (obj) => dispatch(actions.updateProfileObjects(obj)),
    setInitialState: (data) => dispatch(actions.setInitialState(data)),
    logOutFeUser: (obj) => dispatch(actions.logOutFeUser(obj)),
    getCart: () => dispatch(actions.getCart()),
    getWatchlists: () => dispatch(actions.getWatchlists()),
    removeFromFeCart: (obj) => dispatch(actions.removeFromFeCart(obj)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(Navigation)));

